import * as classnames from 'classnames/bind'
import * as React from 'react'
import Brand from '../../components/Brand'
import iconStyles from '../../components/Icon/icon.scss'
import { NavContainer, NavItem, NavLink } from '../Nav'
import styles from './footer.scss'

const cx = classnames.bind({ ...styles, ...iconStyles })

class Footer extends React.Component {

  public render() {
    const dt: Date = new Date()

    return (
      <footer className={cx('footer')}>
        <div className={cx('container')}>
          <div className={cx('footer__inner')}>
            <div className={cx('brand')}>
              <Brand theme="dark" />
            </div>
            <NavContainer className={cx('nav')}>
              <NavItem className={cx('nav__item')}>
                <NavLink className={cx('nav__link')} to="/explore">探索講座</NavLink>
              </NavItem>
              <NavItem className={cx('nav__item')}>
                <NavLink className={cx('nav__link')} to="/recruit">成為講者</NavLink>
              </NavItem>
              <NavItem className={cx('nav__item')}>
                <NavLink className={cx('nav__link')} to="/terms">使用條款</NavLink>
              </NavItem>
            </NavContainer>
            <div className={cx('copyright')}>
              <p className={cx('copyright__text')}>© {dt.getFullYear()}. Qraft. All Rights Reserved.</p>
            </div>
            <a className={cx('footer-fb')} href="https://www.facebook.com/Qraft-234077063907224/" target="_blank">
              <i className={cx('icon', 'icon-facebook')} />
            </a>
          </div>
        </div>
      </footer>
    )
  }
}

export default Footer



// WEBPACK FOOTER //
// ./src/components/Footer/index.tsx